import React, { Component } from 'react';
import './Footer.css';
import packageJson from '../../package.json'

export default class Footer extends Component {
    render() {
        return (
        <div id="footer">
            <div className="hlafwidth">SCOP2 2021 / supported by the UK Medical Research council (MRC)</div>
            <div className="hlafwidth">Build {packageJson.version}</div> 
            <div className="fullwidth">
                <p xmlnscc="http://creativecommons.org/ns#" xmlnsdct="http://purl.org/dc/terms/">
                    <span property="dct:title">Structural Classification of Proteins </span>
                    by 
                    <span property="cc:attributionName"> Antonina Andreeva, Eugene Kulesha, Julian Gough, Alexey Murzin </span>
                    is licensed under <a className="cclink" href="http://creativecommons.org/licenses/by/4.0">CC BY 4.0</a>
                </p>
            </div>
        </div>
        );
    }
}
